// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__x8XQI","head":"ProcedureTableInfo_head__2TpyY"};